// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ineligibility-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.ineligibility-dialog-content {
  background: #fff;
  padding: 1.25rem 2rem;
  border-radius: 0.5rem;
  text-align: center;
  box-shadow: 0 0.13rem 0.6rem rgba(0, 0, 0, 0.1);
  max-width: 31rem;
  width: 90%;
}

.ineligibility-dialog-content h1 {
  font-size: 1.5rem;
  margin-bottom: 1.25rem;
}

.ineligibility-dialog-content p {
  font-size: 1rem;
  margin-bottom: 1.25rem;
}

.ineligibility-dialog-content button {
  background-color: #6200ea;
  color: #fff;
  border: none;
  padding: 0.6rem 1.25rem;
  border-radius: 0.25rem;
  cursor: pointer;
  font-size: 1rem;
}

.ineligibility-dialog-content button:hover {
  background-color: #3700b3;
}

.ineligibility-dialog-actions {
  display: flex;
  justify-content: center;
  margin-top: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/app/main/quoting/ineligibility-dialog/ineligibility-dialog.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AACF;;AAEA;EACE,gBAAA;EACA,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,+CAAA;EACA,gBAAA;EACA,UAAA;AACF;;AAEA;EACE,iBAAA;EACA,sBAAA;AACF;;AAEA;EACE,eAAA;EACA,sBAAA;AACF;;AAEA;EACE,yBAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,sBAAA;EACA,eAAA;EACA,eAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,gBAAA;AACF","sourcesContent":[".ineligibility-dialog-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.ineligibility-dialog-content {\n  background: #fff;\n  padding: 1.25rem 2rem;\n  border-radius: 0.5rem;\n  text-align: center;\n  box-shadow: 0 0.13rem 0.6rem rgba(0, 0, 0, 0.1);\n  max-width: 31rem;\n  width: 90%;\n}\n\n.ineligibility-dialog-content h1 {\n  font-size: 1.5rem;\n  margin-bottom: 1.25rem;\n}\n\n.ineligibility-dialog-content p {\n  font-size: 1rem;\n  margin-bottom: 1.25rem;\n}\n\n.ineligibility-dialog-content button {\n  background-color: #6200ea;\n  color: #fff;\n  border: none;\n  padding: 0.6rem 1.25rem;\n  border-radius: 0.25rem;\n  cursor: pointer;\n  font-size: 1rem;\n}\n\n.ineligibility-dialog-content button:hover {\n  background-color: #3700b3;\n}\n\n.ineligibility-dialog-actions {\n  display: flex;\n  justify-content: center;\n  margin-top: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
